import React, { useState } from "react";
import {
  CloseCrossMini,
  EditMini,
  InfoMini,
  TrashMini,
} from "../../assets/SvgIcons";
import { BasicTextInput } from "../../components/FormComponent/BasicTextInput";
import { MixedSelectAndInputField } from "../../components/FormComponent/MixedSelectAndInputField";
import BasicSelectInput from "../../components/FormComponent/BasicSelectInput";

const countryCodeOptions = [
  "🇦🇺 +61",
  "🇧🇩 +880",
  "🇧🇪 +32",
  "🇧🇷 +55",
  "🇨🇦 +1",
  "🇨🇳 +86",
  "🇨🇭 +41",
  "🇩🇪 +49",
  "🇪🇸 +34",
  "🇫🇷 +33",
  "🇬🇧 +44",
  "🇮🇩 +62",
  "🇮🇱 +972",
  "🇮🇳 +91",
  "🇯🇵 +81",
  "🇰🇷 +82",
  "🇰🇼 +965",
  "🇲🇾 +60",
  "🇲🇽 +52",
  "🇳🇱 +31",
  "🇳🇴 +47",
  "🇳🇿 +64",
  "🇵🇱 +48",
  "🇵🇭 +63",
  "🇺🇦 +380",
  "🇺🇸 +1",
  "🇮🇪 +353",
  "🇷🇺 +7",
  "🇸🇬 +65",
  "🇸🇪 +46",
  "🇹🇷 +90",
  "🇺🇦 +380",
  "🇿🇦 +27",
];
const userProfileInfo = {
  name: "Md Shefat Zeon",
  imgurl: "",
  customerID: "008 315 443",
};

const UserProfile = () => {
  const dealer = JSON.parse(localStorage.getItem("dealer"));
  const [formData1, setFormData1] = useState({
    company: "",
    typeOfBusiness: "",
    country: "",
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    countryCode: "",
    username: "",
    password: "",
    confirmPassword: "",
    preferredLanguage: "",
  });
  const handleChangeFormData1 = (e) => {
    const { name, value } = e.target;
    setFormData1({
      ...formData1,
      [name]: value,
    });
  };
  const handleSubmitDealerRegistration = () => {
    console.log(formData1);
  };

  return (
    <div className=" w-full lg:p-4 md:p-4 sm:p-0">
      <h1 className="lg:text-4xl md:text-2xl sm:text-xl mb-8">Profile</h1>

      <div>
        <div className=" pb-6 border-b">
          <div className="flex items-center gap-6">
            <div className="flex ">
              {" "}
              <img
                src={dealer?.avatar}
                height={120}
                width={120}
                className="rounded-full border"
                alt=""
              />
              <div className="flex flex-col gap-1 justify-center items-center ml-[-24px]">
                <button className="p-2 bg-primary rounded-full">
                  {" "}
                  {CloseCrossMini}{" "}
                </button>
                <button className="p-2 bg-primary rounded-full">
                  {" "}
                  {EditMini}{" "}
                </button>
              </div>
            </div>
            <div>
              <p className="lg:text-[20px] md:text-[18px] sm:text-[16px] ">
                {dealer?.companyTitle}
              </p>
              <p className="text-[14px] mb-1">{dealer?.auth?.name}</p>
              <p className="text-[14px] mb-1">Customer ID: {dealer?.cusId}</p>
              {/* <div className="flex text-[14px] items-center gap-1">
                <p className="underline">View PIN</p>
                {InfoMini}
              </div> */}
            </div>
          </div>{" "}
        </div>

        <h1 className="lg:text-3xl md:text-xl sm:text-lg mb-4 mt-8">
          Personal information
        </h1>

        <form className="pb-6 border-b">
          <BasicTextInput
            label={"Full name"}
            type={"text"}
            id={"firstName"}
            name={"firstName"}
            value={dealer.auth.name}
            onChange={handleChangeFormData1}
            placeholder={"Enter your full name"}
            disabled={true}
          />

          <BasicTextInput
            label={"Country"}
            type={"text"}
            id={"Country"}
            name={"Country"}
            value={dealer.country}
            onChange={handleChangeFormData1}
            placeholder={"Enter your full name"}
            disabled={true}
          />

          <MixedSelectAndInputField
            label="Phone Number"
            value1={formData1?.countryCode}
            onChange1={handleChangeFormData1}
            options1={countryCodeOptions}
            name1="countryCode"
            defaultDisabledValue1="🇧🇩 +880"
            value2={dealer.auth.phone}
            onChange2={handleChangeFormData1}
            id2="phone"
            name2="phone"
            isRequired={true}
          />

          <BasicSelectInput
            label={"Preferred language"}
            name={"Your preferred language"}
            onChange={handleChangeFormData1}
            value={dealer.preferredLang}
            options={["English", "Arabic", "Persian", "Hindi"]}
            // defaultDisabledValue={dealer.preferredLang}
          />
        </form>

        <div className="mb-4 mt-8 flex items-center gap-2">
          <h1 className="lg:text-3xl md:text-xl sm:text-lg ">
            Trade license information{" "}
          </h1>
          <p className="text-[10px] mt-1 px-2.5 py-1 rounded-full bg-secondary text-white">
            View Only
          </p>
        </div>

        <div className="pb-6 border-b">
          {/* <img src={dealer?.doc?.tl} alt="" /> */}
          <iframe
            src={dealer?.docs?.tl}
            width="100%"
            height="800px"
            title="PDF Viewer"
          ></iframe>
        </div>

        <h1 className="lg:text-3xl md:text-xl sm:text-lg mb-4 mt-8">
          Login information
        </h1>

        <form className="pb-6 border-b">
          <BasicTextInput
            label={"Email address"}
            type={"email"}
            id={"email"}
            name={"email"}
            value={dealer?.auth.email}
            onChange={handleChangeFormData1}
            placeholder={"Enter your email "}
          />

          <BasicTextInput
            label={"Account password"}
            type={"password"}
            id={"password"}
            name={"password"}
            value={formData1?.password}
            onChange={handleChangeFormData1}
            placeholder={"Enter your password "}
          />
        </form>

        {/* CTA TO NEXT PAGE */}
        <div className="flex justify-between items-center w-full my-6">
          <button className="text-sm flex gap-1 items-center">
            {TrashMini} <p className="underline">Delete account</p>
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              handleSubmitDealerRegistration();
            }}
            className="px-12 py-2.5 rounded bg-secondary text-white text-sm"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
